import { IonCol } from '@ionic/react'
import React from 'react'
import HeaderRow from '../headerRow/HeaderRow.component'
import { RowDetails } from '../headerRow/HeaderRow.component'
import { IPHIComponent } from '../../../components/phi/phi.component'

interface HeaderSectionInfo {
  title: string
  titleColor: { color: string }
  data: RowDetails[]
}

export interface IHeaderSection extends IPHIComponent {
  headerSectionInfo: HeaderSectionInfo
}

const HeaderSection: React.FC<IHeaderSection> = (props: IHeaderSection) => {
  const { headerSectionInfo, isPHI } = props
  return (
    <IonCol>
      <h1 qa-id='main_header_title' className='header-title' style={headerSectionInfo.titleColor}>
        {headerSectionInfo.title}
      </h1>
      {headerSectionInfo.data.map((data, idx) => (
        <HeaderRow isPHI={isPHI} rowDetails={data} key={`row_${idx}`} />
      ))}
    </IonCol>
  )
}

export default HeaderSection
